'use client'

import { cx } from './utils/cx'

interface SwitchProps {
  on?: boolean
  onChange?: (next: boolean) => void
  ariaLabel?: string
}

export function Switch({ on, onChange, ariaLabel }: SwitchProps) {
  return (
    <div
      className={cx('st-switch', on && 'on')}
      onClick={() => onChange?.(!on)}
      role="switch"
      aria-checked={!!on}
      aria-label={ariaLabel}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault()
          onChange?.(!on)
        }
      }}>
      <div className="knob" />
    </div>
  )
}
